module.exports = {
	"disputes": {
		"updated_success": "Dispute is successfully updated",
		"id": "ID",
		"status": {
			"title": "Status",
			"received": "Received",
			"in_progress": "In Progress",
			"represented": "Represented",
			"won": "Won",
			"rejected_automatically": "Rejected Automatically",
			"lost_representment": "Lost (Representment)",
			"lost_accepted": "Lost (Accepted)",
			"lost_expired": "Lost (Expired)",
			"pre_arbitration": "Pre-Arbitration",
			"arbitration": "Arbitration",
			"canceled": "Canceled"
		},
		"fraud_type": {
			"title": "Fraud Type",
			"friendly_fraud": "Friendly Fraud",
			"true_fraud": "True Fraud",
			"true_fraud_syndicate": "True fraud Syndicate",
			"third_party_card": "3rd party card",
			"cannot_define": "Cannot define",
			"technical_cbk": "Technical CBK",
			"friendly_fraud_trend": "Friendly Fraud Trend"
		},
		"external_id": "External ID",
		"type": {
			"title": "Type",
			"normal": "Normal",
			"potential": "Potential"
		},
		"player_id": "Player ID",
		"transaction_date": "Transaction date",
		"chargeback_date": "Chargeback date",
		"order_guid": "Order GUID",
		"payment_id": "Payment ID",
		"provider": "Provider",
		"method": "Method",
		"category": "Category",
		"reason": "Reason",
		"deadline": "Deadline",
		"card_number": "Card number",
		"amount": "Amount",
		"external_status": "External status",
		"external_category": "External category",
		"actions": "Actions",
		"days_left": "Days Left",
		"amount_eur": "Amount EUR",
		"dispute_date": "Dispute date",
		"result_date": "Date result",
		"three_ds_status": "3DS status",
		"liability_shift": "Liability shift",
		"order_comment": "Order comments",
		"jurisdiction": "Jurisdiction",
		"dispute": "Dispute",
		"details": {
			"dispute": "Dispute",
			"order": "Order",
			"ip": "IP",
			"user_agent": "User agent",
			"open_in_sphere": "Open the player in Sphere",
			"provider_events": "Provider events",
			"admin_actions": "Our actions",
			"related": "Related disputes",
			"same_player": "This player",
			"same_card": "This card"
		}
	}
};